import {
  UPDATE_OFFERS_DATA,
  HomePageActionTypes,
  IHomePageStoreState,
  TOGGLE_LOADING_GETOFFERS,
  UPDATE_HOME_SEO_DATA,
} from './types';

const initialState: IHomePageStoreState = {
  offersApi: {
    isLoading: false,
    data: [],
  },

  homeSeoData: {
    h1: 'Hotel Booking',
    title: 'Online Hotel Booking | Book Cheap, Budget and Luxury Hotels -Goibibo',
  },
};

export default function homePageReducer(state = initialState, action: HomePageActionTypes) {
  switch (action.type) {
    case UPDATE_HOME_SEO_DATA:
      return {
        ...state,
        homeSeoData: {
          ...action.homeSeoData,
        },
      };
    case UPDATE_OFFERS_DATA:
      return {
        ...state,
        offersApi: {
          ...state.offersApi,
          data: action.actionData,
        },
      };

    case TOGGLE_LOADING_GETOFFERS:
      return {
        ...state,
        offersApi: {
          ...state.offersApi,
          isLoading: action.actionData,
        },
      };

    default:
      return state;
  }
}
